const modalFormPopup = function () {
	const modal = document.getElementById('modal-form');
	const body  = document.body;
	const modalToggles = Array.from(
		document.querySelectorAll('.toggle-modal'),
	);
	
	if ( ! modal || ! modalToggles.length > 0 ) {
		return;
	}

	// Open + Close buttons set to toggle the modal on and off.
	modalToggles.forEach(function (toggle) {
		toggle.addEventListener('click', function (e) {
			e.preventDefault();
			body.classList.toggle('modal-open');
		});
	});
};
export default modalFormPopup;